import * as React from 'react';
import ClearableInput from '@rio-cloud/rio-uikit/ClearableInput';

interface AccountSearchProps {
    value: string;
    onChange: (
        newValue: string,
        event: React.ChangeEvent<HTMLInputElement> | React.MouseEvent<HTMLSpanElement>
    ) => void;
}

export const AccountSearch = React.memo((props: AccountSearchProps) => {
    const { value, onChange } = props;

    return (
        <div className={'input-group flex-1-0'}>
            <span className={'input-group-addon'}>
                <span className={'rioglyph rioglyph-search'} aria-hidden={'true'} />
            </span>
            <ClearableInput value={value} onChange={onChange} />
        </div>
    );
});
